import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/estoque/locaisestoques/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findLocaisEstoques(
  empresa_cnpj,
  id,
  include,
  per_page = 1000
) {
  return search(
    `${path}${id ? `/${id}` : ""}?empresa_cnpj=${empresa_cnpj}${
      include ? `&include=${include}` : ""
    }${per_page && `&per_page=${per_page}`}`,
    "GET",
    headers
  );
}
